import { Plus } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  onAddBlock: () => void
}

export const AddBlockWithBlocks: React.FC<Props> = ({ onAddBlock }) => (
  <div className={css.add_block} onClick={onAddBlock}>
    <div className={css.icon}>
      <Plus />
    </div>
    <span className={css.add_block_text}>Add block</span>
  </div>
)
